import{jsx as r}from"react/jsx-runtime";import{createSvgIcon as t}from"@mui/material/utils";var a=t(r("path",{d:"M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"}),"ArrowForwardIos");export{a as default};
//# sourceMappingURL=ArrowForwardIos.js.map
